// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GbsJ1","circle":"Spinner_circle__60lSS","animation":"Spinner_animation__okooq"};